import Calendly from 'builder/components/Calendly'
import { Container } from './styles'

const ScheduleSessionView = () => {
  return (
    <Container>
      <Calendly />
    </Container>
  )
}

export default ScheduleSessionView
